import { FC, PropsWithChildren, RefAttributes, useEffect, useState } from 'react';
import { useSwiper, Swiper, SwiperProps, SwiperRef } from 'swiper/react';

import { Colors, Spacing } from '@lichtblick/theme';

export const useSliderState = () => {
  const swiper = useSwiper(); // cannot be destructured, otherwise "this" is undefined on called functions
  // swiper is not reactive WTF??
  const [sliderState, setSliderState] = useState({ isBeginning: true, isEnd: false });

  useEffect(() => {
    swiper.on('slideChange', () => swiper && setSliderState({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd }));
  }, [swiper]);

  return { ...sliderState, swiper };
};

export const BasicSlider: FC<RefAttributes<SwiperRef> & PropsWithChildren<SwiperProps>> = ({ children, ...props }) => (
  <>
    <style type="text/css">{`
    .swiper{ 
      --swiper-pagination-color: ${Colors.Black};
      --swiper-pagination-bullet-inactive-color: ${Colors.Gray};
      --swiper-pagination-bullet-inactive-opacity: 1;
      --swiper-pagination-bullet-size: 0.5rem;
      --swiper-pagination-bullet-horizontal-gap: calc(${Spacing.S} / 2);
      --swiper-pagination-bottom: -4rem;
      overflow-y: visible; 
      margin-top: ${Spacing.L};
      margin-bottom: ${Spacing.Xl};
    }
    .swiper-pagination-horizontal {
      display: flex; 
      align-items: center; 
      justify-content: center; 
      height: 1.5rem;
    }
    `}</style>
    <Swiper {...props}>{children}</Swiper>
  </>
);
